import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import {
  MrfiktivInvoicePartyDtoGen,
  MrfiktivInvoicePartyViewModelGen,
  MrfiktivPartnerViewModelGen,
  MrfiktivReferenceGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { Address, IAddress } from "./address.entity";
import { Reference } from "./reference.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";

@IsFilterable
class InvoicePartyBase implements MrfiktivInvoicePartyViewModelGen {
  /** Name of the party */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceParty.name"
  })
  name: string;

  /** Email of the party */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceParty.email"
  })
  email?: string | undefined;

  /** Phone number of the party */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceParty.phone"
  })
  phone?: string | undefined;

  /** Tax number of the party */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceParty.taxnumber"
  })
  taxnumber?: string | undefined;

  /** Address of the party */
  @FilterConfig({
    type: Address,
    displayName: "objects.invoiceParty.address"
  })
  address: IAddress;

  /** Reference of the party */
  @FilterConfig({
    type: Reference,
    displayName: "objects.invoiceParty.ref"
  })
  ref?: MrfiktivReferenceGen | undefined;

  constructor(date?: MrfiktivInvoicePartyViewModelGen | IInvoiceParty) {
    this.name = date?.name || "";
    this.email = date?.email;
    this.phone = date?.phone;
    this.taxnumber = date?.taxnumber;
    this.address = new Address(date?.address);
    this.ref = date?.ref ? new Reference(date.ref) : undefined;
  }

  map(date?: IInvoiceParty) {
    this.name = date?.name || "";
    this.email = date?.email;
    this.phone = date?.phone;
    this.taxnumber = date?.taxnumber;
    this.address = new Address(date?.address);
    this.ref = date?.ref ? new Reference(date.ref) : undefined;
  }

  get dto(): MrfiktivInvoicePartyDtoGen {
    return {
      address: this.address,
      email: this.email,
      name: this.name,
      phone: this.phone,
      ref: this.ref,
      taxnumber: this.taxnumber
    };
  }
}

type IInvoiceParty = InvoicePartyBase;
const InvoiceParty = Filter.createForClass(InvoicePartyBase);

export { IInvoiceParty, InvoiceParty };

export class PartnerInvoiceParty extends InvoiceParty {
  /**
   *
   * @param partner
   */
  constructor(partner: MrfiktivPartnerViewModelGen) {
    super();

    this.name = partner.companyName || "";
    this.email = partner.contact?.email;
    this.phone = partner.contact?.phone;
    // FIXME: this.taxnumber = partner.taxnumber;
    this.address = new Address(partner.address);
    this.ref = {
      refId: partner.id,
      refType: ResourceEnum.PARTNER
    };
  }
}
